import React, { useEffect } from 'react';

import { RegDiv } from '../..';

function CNConfirm ({onYes, onNo}){
    
    useEffect(() => {      
         
    });

    return(
        <RegDiv flexdirection="row"> 
            <RegDiv width="25vw"></RegDiv> 
            <RegDiv width="40vw">
            <RegDiv height="100px" >
                <h3>您确定要取消吗?</h3>
            </RegDiv>
            <RegDiv flexdirection="row" mobileflexdirection="row" height="100px">
                <RegDiv width ="20vw" mobilewidth="20vw">
                    <button onClick={onYes}
                    style={{
                    width: '80px',
                    height: '40px',                  
                    }}
                    >   
                    是</button> 
                </RegDiv>
                <RegDiv width="20vw" mobilewidth="20vw">
                    <button onClick={onNo}
                    style={{
                        width: '80px',
                        height: '40px',                  
                        }}
                    >
                        否</button>  
                </RegDiv>
            
            </RegDiv>
            </RegDiv>
            <RegDiv width="25vw"></RegDiv>  
        </RegDiv>
    )
}

export default CNConfirm;